import Typography from '@material-tailwind/react/components/Typography'
import React, { useMemo } from 'react'

const articles = [
  {
    title: "Annales DCG UE 8 : Systèmes d'information et de gestion",
    link: 'https://ressources.lamacompta.co/annales-dcg-ue-8-systemes-dinformation-et-de-gestion/',
    image:
      'https://ressources.lamacompta.co/content/images/size/w2000/2025/03/Les-annales-du-DCG.png',
    subtitle:
      "Voici les annales de l'UE 8 du DCG : Systèmes d'information et de gestion sur les dernières années 👇",
  },
  {
    title: 'En immersion dans le cabinet Numbr de Nantes',
    link: 'https://ressources.lamacompta.co/en-immersion-dans-le-cabinet-numbr-de-nantes/',
    image:
      'https://ressources.lamacompta.co/content/images/size/w2000/2024/04/Miniature-Youtube-Numbr.png',
    subtitle:
      'Découvrez le cabinet Numbr avec Judie qui part la rencontre des cabinets d’expertise et de conseil les plus attractifs pour découvrir ce qu’il se passe vraiment !',
  },
  {
    title: 'En immersion dans le cabinet Comptasanté de Nantes',
    link: 'https://ressources.lamacompta.co/en-immersion-dans-le-cabinet-comptasante-de-nantes/',
    image:
      'https://ressources.lamacompta.co/content/images/size/w2000/2025/04/Miniature-YouTube-en-immersion-1.png',
    subtitle:
      '👋 Salut à tous, moi c’est Judie ! Je pars à la rencontre des cabinets comptables pour vous faire découvrir leur quotidien… de l’intérieur.',
  },
  {
    title: 'Déterminez le salaire juste pour vous 💰',
    link: 'https://ressources.lamacompta.co/determinez-le-salaire-juste-pour-vous/',
    image:
      'https://ressources.lamacompta.co/content/images/size/w2000/2024/09/Ne-gocier-son-salaire--5-.jpg',
    subtitle:
      'Découvrez comment déterminer le salaire juste pour vous en fonction de votre expérience, de votre secteur d’activité et de votre localisation.',
  },
  {
    title: 'Le secret pour négocier le salaire que vous méritez',
    link: 'https://ressources.lamacompta.co/le-secret-pour-negocier-le-salaire-que-vous-meritez/',
    image:
      'https://ressources.lamacompta.co/content/images/size/w2000/2024/09/Ne-gocier-son-salaire.jpg',
    subtitle:
      'Découvrez comment négocier le salaire que vous méritez en fonction de votre expérience, de votre secteur d’activité et de votre localisation.',
  },
  {
    title: 'Comment gagner au moins 2 jours de productivité par mois ?',
    link: 'https://ressources.lamacompta.co/content/images/size/w2000/2025/02/Formation-Deauville-Pre-sentation.jpg',
    image:
      'https://ressources.lamacompta.co/content/images/size/w2000/2024/11/E-lection-CNOEC-2024.png',
    subtitle:
      "Il y a quelques mois, Audrey Brullon Co-fondatrice de Lamacompta s'est rendue à Deauville pour présenter une formation sur le gain de productivité. Son défi, vous prouver qu'en mettant en place 6 actions vous pourrez gagner au moins de jours de travail par mois !",
  },
]

export const BlogColumn = () => (
  <div className="h-full px-4 py-6 space-y-2 bg-blue-gray-900 bg-opacity-5">
    <Typography className="font-medium text-night">
      À découvrir sur le blog
    </Typography>
    <Articles />
  </div>
)

const Articles = () => {
  const index = useMemo(() => Math.floor(Math.random() * articles.length), [])

  return (
    <ul className="space-y-2">
      <Article article={articles[index]} />
    </ul>
  )
}

const Article = ({
  article: { link, title, image, subtitle },
}: {
  article: { title: string; link: string; image: string; subtitle: string }
}) => (
  <li role="article">
    <article className="grid grid-cols-1 gap-2 space-y-2 md:grid-cols-3">
      <img
        src={image}
        alt={`Miniature de l'article ${title}`}
        className="rounded-md md:col-span-2"
      />

      <p className="font-medium text-night md:col-span-3">{title}</p>
      <p className="md:col-span-3">{subtitle}</p>
      <a
        href={link}
        title={`Lire l'article ${title}`}
        rel="noreferrer"
        target="_blank"
        className="font-medium underline text-night md:col-span-3"
      >
        Lire la suite
      </a>
    </article>
  </li>
)
